// extracted by mini-css-extract-plugin
module.exports = {"Image":"SatisfacionEncuesta_Image__EtLxd","card":"SatisfacionEncuesta_card__2aWW2","cardTitle":"SatisfacionEncuesta_cardTitle__hwRuw","button":"SatisfacionEncuesta_button__UQgC5"};